import script from "./GlobalSearchView.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalSearchView.vue?vue&type=script&setup=true&lang=js"

import "./GlobalSearchView.vue?vue&type=style&index=0&id=01677c32&lang=scss&scoped=true"
import "./GlobalSearchView.vue?vue&type=style&index=1&id=01677c32&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01677c32"]])

export default __exports__